// extracted by mini-css-extract-plugin
export var container = "whitepaper-module--container--BY+4M";
export var title = "whitepaper-module--title--Qx9J6";
export var ethhButton = "whitepaper-module--ethhButton--laD7-";
export var anchor = "whitepaper-module--anchor--3aAm-";